import React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsx mdx */

import DefaultLayout from "/zeit/767b4790/node_modules/gatsby-theme-carbon/src/templates/Default.js";
export const _frontmatter = {};

const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope");
  return <div {...props} />;
};

const PageDescription = makeShortcode("PageDescription");
const AnchorLinks = makeShortcode("AnchorLinks");
const AnchorLink = makeShortcode("AnchorLink");
const Row = makeShortcode("Row");
const Column = makeShortcode("Column");
const Caption = makeShortcode("Caption");
const DoDontRow = makeShortcode("DoDontRow");
const DoDont = makeShortcode("DoDont");
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <PageDescription mdxType="PageDescription">
      <p>{`Inconsistencies in grammar and style interrupt concentration. Help users focus on your product by following these guidelines and applying them consistently.`}</p>
    </PageDescription>
    <AnchorLinks mdxType="AnchorLinks">
      <AnchorLink mdxType="AnchorLink">Capitalization</AnchorLink>
      <AnchorLink mdxType="AnchorLink">Verb tense</AnchorLink>
      <AnchorLink mdxType="AnchorLink">Active and passive voice</AnchorLink>
      <AnchorLink mdxType="AnchorLink">First and second person</AnchorLink>
      <AnchorLink mdxType="AnchorLink">Formal vs. casual tone</AnchorLink>
      <AnchorLink mdxType="AnchorLink">Can, may, and might</AnchorLink>
      <AnchorLink mdxType="AnchorLink">References</AnchorLink>
    </AnchorLinks>
    <h2>{`Capitalization`}</h2>
    <h3>{`Use sentence-case capitalization`}</h3>
    <p>{`Use sentence-case capitalization for all UI text elements. This style is predominantly lowercase. Capitalize only the initial letter of the first word in the text and other words that require capitalization, such as proper nouns. For example, labels in a form would be written as “First name” and “Email address.”`}</p>
    <p>{`The image below shows a page title, tabs, a module title, link text, button text, table headers, and table content all following the sentence case rule.`}</p>
    <Row mdxType="Row">
      <Column colLg={8} mdxType="Column">
        <span {...{
          "className": "gatsby-resp-image-wrapper",
          "style": {
            "position": "relative",
            "display": "block",
            "marginLeft": "auto",
            "marginRight": "auto",
            "maxWidth": "1152px"
          }
        }}>{`
      `}<span parentName="span" {...{
            "className": "gatsby-resp-image-background-image",
            "style": {
              "paddingBottom": "62.5%",
              "position": "relative",
              "bottom": "0",
              "left": "0",
              "backgroundImage": "url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAANCAYAAACpUE5eAAAACXBIWXMAAAsSAAALEgHS3X78AAABxUlEQVQ4y61Ty27aUBD1j7IjqKFd8FBVJSKom1bdIXVRpGyqbLropot8C4KKoBjkBzbg5/UDv07vDNiN0i5aKZaOfc/M3LkzZ64VvOBTVRWU8XiMi4s23rzu4vLyFdrt9n+h0+mg1WphMplwUuXDx094++4ao5v3uLoeYTgcYjAYMGhd836//wd6vR77ut0uptPpKWGaA64oID/IKsD3fSRJgjzPEYZhw/+55SSJ4bkO4kigkElc14VhGNA0DY7jcML9fo/tdsvr4/HIqO1xHDc2rlAIAV3XpfPQnERJyVYUBXOqUFVVHA6/YzTdwKO6kb4jStlZSS/ICmkTtfe07Ke8tpVl+azBnBOcIxjccpZlXG6apg3qFp7b4jhBmgiohsDoDriRGN6esLbOFVqWhdlshtVqxdpRq8vlEovFApvNhm3r9Rrz+VzaH2AaGn4+aPjy/RGfvy1x+0PH13sLtnPW0PM8HgAJTEKTfqZpMshXi3/SeQ9P8sD3EPkmhGegylxGWWbcuBIEQbOZrglx27ax2+2YE+gQmjLFCI4JsbVsabPhB0IeEja6KzRBqiKKIp4mgZJSopqT728xhJrXN0J56X/5F72ZrgG4WjPBAAAAAElFTkSuQmCC')",
              "backgroundSize": "cover",
              "display": "block"
            }
          }}></span>{`
  `}<img parentName="span" {...{
            "className": "gatsby-resp-image-image",
            "alt": "Sentence case for UI elements",
            "title": "Sentence case for UI elements",
            "src": "/static/3375801220657f773adb8a2e06af79d8/3cbba/sentence_case_786.png",
            "srcSet": ["/static/3375801220657f773adb8a2e06af79d8/7fc1e/sentence_case_786.png 288w", "/static/3375801220657f773adb8a2e06af79d8/a5df1/sentence_case_786.png 576w", "/static/3375801220657f773adb8a2e06af79d8/3cbba/sentence_case_786.png 1152w", "/static/3375801220657f773adb8a2e06af79d8/392b1/sentence_case_786.png 1472w"],
            "sizes": "(max-width: 1152px) 100vw, 1152px",
            "style": {
              "width": "100%",
              "height": "100%",
              "margin": "0",
              "verticalAlign": "middle",
              "position": "absolute",
              "top": "0",
              "left": "0"
            },
            "loading": "lazy"
          }}></img>{`
    `}</span>
        <Caption mdxType="Caption">Example of a product page using sentence-style capitalization</Caption>
      </Column>
    </Row>
    <p>{`Sentence-style capitalization makes it easy for readers to distinguish between common nouns and proper nouns, and is generally considered the quickest form to read.`}</p>
    <blockquote>
      <p parentName="blockquote">{`Do not capitalize the names of features and components unless they are sold separately or are trademarked.`}</p>
      <cite>- The IBM Style Guide: Conventions for Writers and Editors</cite>
    </blockquote>
    <p>{`Carbon does not consider UI elements within a product to be proper nouns. Nor does Carbon support a concept of “important words” or “specialness.” Determining whether something is important or special is highly subjective and can result in inconsistencies across an organization.`}</p>
    <p>{`Unless the name is a product or service name, or is trademarked, always use sentence-style capitalization.`}</p>
    <p>{`In the following examples, the capitalization shows that Padlock, Visual Recognition, and IBM Cloud are either products or services.`}</p>
    <DoDontRow mdxType="DoDontRow">
  <DoDont text="Secure your enterprise applications with Padlock." aspectRatio="1:1" mdxType="DoDont" />
  <DoDont text="Visual Recognition is a service on IBM Cloud." aspectRatio="1:1" mdxType="DoDont" />
    </DoDontRow>
    <h3>{`Referring to UI elements`}</h3>
    <p>{`When writing about a UI element, use the same capitalization as used in the UI. For example, if an input field is labeled “Name” then you refer to this as the Name input field. Similarly, if a drop-down menu has the label “Country” next to it, then it is correct to refer to the Country drop-down menu. Where a product page is titled “My network,” you refer to this in writing as follows: “Enter your network information in the My network page.”`}</p>
    <DoDontRow mdxType="DoDontRow">
  <DoDont text="To enter network information, go to the My network page." caption="How to refer to UI elements in text" aspectRatio="1:1" mdxType="DoDont" />
  <DoDont type="dont" text="To enter network information, go to the My Network page." aspectRatio="1:1" mdxType="DoDont" />
    </DoDontRow>
    <h3>{`When to use capital letters`}</h3>
    <p>{`Capital letters are reserved for the following:`}</p>
    <ul>
      <li parentName="ul">{`“Carbon” or the “Carbon Design System” (i.e. the name of IBM’s official design system)`}</li>
      <li parentName="ul">{`“IBM” or any other company or organization name`}</li>
      <li parentName="ul">{`Any official, trademarked product or service (whether from IBM or not) - unless they intentionally use a lowercase letter at the beginning, such as the iPhone`}</li>
      <li parentName="ul">{`Any initialisms (e.g. BBC, HTML, etc.) or acronyms (e.g. NASA, NATO, etc.)`}</li>
      <li parentName="ul">{`Any people`}</li>
      <li parentName="ul">{`Any country / place names`}</li>
      <li parentName="ul">{`When referring to any UI labels that are themselves capitalized`}</li>
      <li parentName="ul">{`When the word begins a sentence or phrase`}</li>
    </ul>
    <p>{`If it’s not in the list above, it should not be capitalized.`}</p>
    <p>{`Sometimes official company and product names use non-standard capitalization. If you refer to any of these, ensure you write them accurately. Here are some examples (all written correctly):`}</p>
    <ul>
      <li parentName="ul">{`developerWorks`}</li>
      <li parentName="ul">{`GitHub`}</li>
      <li parentName="ul">{`iTunes`}</li>
      <li parentName="ul">{`JavaScript`}</li>
      <li parentName="ul">{`WebSphere`}</li>
    </ul>
    <h3>{`Do not use title case capitalization`}</h3>
    <p><strong parentName="p">{`Title (or headline) case capitalization`}</strong>{` is where the first letter of most words is capitalized, but not articles, conjunctions, or prepositions (except if any of these are the first or last word in the sentence or phrase).`}</p>
    <p>{`Title case is difficult to implement consistently across an organization because:`}</p>
    <ol>
      <li parentName="ol">
        <p parentName="li">{`It requires everyone who writes any copy to understand and follow fairly complex grammatical rules about which words should and shouldn’t be capitalized, and`}</p>
      </li>
      <li parentName="ol">
        <p parentName="li">{`It relies on a subjective viewpoint of what is considered “important” or “special” and that viewpoint being communicated or understood somehow.`}</p>
      </li>
    </ol>
    <p>{`Title case can also slow reading and comprehension down as it is more difficult for readers to distinguish between proper nouns and common nouns.`}</p>
    <DoDontRow mdxType="DoDontRow">
  <DoDont text="Secure your enterprise applications with Padlock." caption="Only capitalize proper nouns, such as product names." aspectRatio="1:1" mdxType="DoDont" />
  <DoDont type="dont" text="Secure your Enterprise Applications with Padlock." aspectRatio="1:1" mdxType="DoDont" />
    </DoDontRow>
    <h3>{`Do not use all caps capitalization`}</h3>
    <p><strong parentName="p">{`All caps (or uppercase) capitalization`}</strong>{` is where every letter is capitalized.`}</p>
    <p>{`All caps capitalization has been shown to be slower to read (especially when text is more than a few words) as individual letter shapes are less distinguishable from each other—they are the same height and have no ascenders or descenders. This style also typically requires more space in the UI per letter than sentence case does.`}</p>
    <p>{`In addition, it can be difficult for the reader to distinguish between proper nouns and common nouns. In the first example below, it’s easy to distinguish product names from features whereas it takes longer to make these distinctions when the text is in all caps.`}</p>
    <DoDontRow mdxType="DoDontRow">
  <DoDont text="Get started with Watson Studio to build, test, and deploy your own custom models to iOS." aspectRatio="1:1" mdxType="DoDont" />
  <DoDont type="dont" text="GET STARTED WITH WATSON STUDIO TO BUILD, TEST, AND DEPLOY YOU OWN CUSTOM MODELS TO IOS." aspectRatio="1:1" mdxType="DoDont" />
    </DoDontRow>
    <h3>{`Capitalizing proper nouns`}</h3>
    <p>{`The names of people, places, and products are proper nouns and therefore all take initial capitals. Examples of proper nouns are:`}</p>
    <ul>
      <li parentName="ul">{`Eliot Noyes`}</li>
      <li parentName="ul">{`IBM Watson Studio`}</li>
      <li parentName="ul">{`Paris, France`}</li>
      <li parentName="ul">{`Porsche Boxster`}</li>
    </ul>
    <p>{`There are many words that can act as either a common noun or a proper noun, depending on the context. So, you always need to think about how the word is being used. Here are some examples:`}</p>
    <table>
      <thead parentName="table">
        <tr parentName="thead">
          <th parentName="tr" {...{
            "align": null
          }}>{`Word`}</th>
          <th parentName="tr" {...{
            "align": null
          }}>{`Used as a common noun`}</th>
          <th parentName="tr" {...{
            "align": null
          }}>{`Used as a proper noun`}</th>
        </tr>
      </thead>
      <tbody parentName="table">
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`agile`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`The group uses agile tools and processes`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Debs referred her manager to the Agile Manifesto`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`design`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Jodi works in the design organization`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Jodi works for IBM Design`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`editor`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Joe used a text editor to update the config file`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Joe used IBM Flow Editor to define his data models`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`front end developer`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Jane is hoping to recruit a front end developer`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Megan’s job title is Senior Front End Developer`}</td>
        </tr>
      </tbody>
    </table>
    <h3>{`Capitalizing abbreviations`}</h3>
    <p><strong parentName="p">{`IBM product and service names`}</strong></p>
    <p>{`When referencing the name of any IBM product, use the official (full) name, not an abbreviation or just the product name initials, unless a shortened name has been specifically approved, as with IBM CICS.`}</p>
    <DoDontRow mdxType="DoDontRow">
  <DoDont text="Experience WebSphere Application Server on IBM Cloud..." aspectRatio="1:1" mdxType="DoDont" />
  <DoDont type="dont" text="Experience WAS on IBM Cloud..." aspectRatio="1:1" mdxType="DoDont" />
    </DoDontRow>
    <p>{`Use all uppercase letters for well-recognized abbreviations. This applies to both initialisms, such as IBM, and to acronyms, such as GIF.`}</p>
    <ul>
      <li parentName="ul">{`ASCII`}</li>
      <li parentName="ul">{`CAPTCHA`}</li>
      <li parentName="ul">{`FAQ`}</li>
      <li parentName="ul">{`HTML`}</li>
      <li parentName="ul">{`OK (not Ok or Okay)`}</li>
      <li parentName="ul">{`WDSL`}</li>
    </ul>
    <p>{`If there’s a chance that an abbreviation might not be known to the target audience, it’s good practice to spell it out in full the first time you use it. However, don’t spell out commonly known abbreviations, for example PDF, CEO, AM/PM.`}</p>
    <h3>{`Capitalizing all other words`}</h3>
    <p>{`Unless the word begins a sentence, phrase, or UI element name, don’t give it a capital letter.`}</p>
    <p>{`Don’t give a word a capital letter to denote “specialness.” If you want to emphasize a particular word or phrase within a sentence, use italic or bold formatting (but not both).`}</p>
    <DoDontRow mdxType="DoDontRow">
  <DoDont text="You can use a global policy to apply changes to all users." aspectRatio="1:1" mdxType="DoDont" />
  <DoDont type="dont" text="You can use a Global Policy to apply changes to all users." aspectRatio="1:1" mdxType="DoDont" />
    </DoDontRow>
    <h2>{`Active and passive voice`}</h2>
    <p>{`The `}<em parentName="p">{`active voice`}</em>{` is direct and punchy, and emphasizes the subject of the sentence. The subject clearly “acts upon” the verb (hence, “active”). For example, “John ate the apple.” In situations where either voice will work, generally choose the active voice for more directness.`}</p>
    <DoDontRow mdxType="DoDontRow">
  <DoDont caption="Do use active voice when appropriate." text="Next, the admin configures access privileges." aspectRatio="1:1" mdxType="DoDont" />
  <DoDont type="dont" caption="Don’t use passive voice when active voice will suffice." text="Next, access privileges are configured by the admin." aspectRatio="1:1" mdxType="DoDont" />
    </DoDontRow>
    <p>{`The `}<em parentName="p">{`passive voice`}</em>{`, on the other hand, flips the construction so that the subject is secondary to the verb and object (hence, “passive”). Often, the subject is not even included in the sentence. For example, “`}<em parentName="p">{`The apple was eaten by John`}</em>{`” or just “`}<em parentName="p">{`The apple was eaten`}</em>{`.” Only sentences that contain direct objects can be constructed in the passive voice. Thus, “`}<em parentName="p">{`John ate`}</em>{`” cannot be constructed passively.`}</p>
    <p>{`The passive voice makes for a more natural tone in certain use cases. For example, if the true subject of the sentence is a system, and the human is secondary, passive voice can be acceptable.`}</p>
    <DoDontRow mdxType="DoDontRow">
  <DoDont caption="Do use passive voice when appropriate." text="The database needs to be rebooted." aspectRatio="1:1" mdxType="DoDont" />
  <DoDont type="dont" caption="Don’t use active voice when passive voice is more appropriate." text="Someone needs to reboot the database." aspectRatio="1:1" mdxType="DoDont" />
    </DoDontRow>
    <h2>{`First and second person`}</h2>
    <p>{`Engage your readers by using second person `}<strong parentName="p">{`(you, your)`}</strong>{` where appropriate. First person `}<strong parentName="p">{`(I, we, our)`}</strong>{` focuses on the writer rather than the audience, which is rarely appropriate in UI or technical contexts. Avoid the first person unless you have a compelling reason to use it.`}</p>
    <p>{`One exception to this is in the case of possessive adjectives in the UI. You can use first person in headings or labels that are very specific to the user or customer data, such as “My Account” or “My Usage.” In explanatory text for the heading or label, however, use second person. For example, `}<em parentName="p">{`“Your usage is calculated from the first day of the month.”`}</em></p>
    <h2>{`Formal vs. casual tone`}</h2>
    <p>{`While a more formal tone is often appropriate for technical and business writing, a more casual tone is becoming increasingly accepted (and expected) in UI and supporting materials.`}</p>
    <ul>
      <li parentName="ul">{`Don’t be afraid to use `}<strong parentName="li">{`contractions`}</strong>{`. When they fit the context and improve flow, go for it.`}</li>
      <li parentName="ul">{`Beginning sentences with `}<strong parentName="li">{`and, but, or so`}</strong>{` is not always forbidden. When it allows for shorter, scannable sentences, they can be used. Do not overuse these devices, especially in instructional content. For example, `}<em parentName="li">{`“You can deploy an app to the cloud during lunch hour. But it’s not required.”`}</em>{` works for `}<em parentName="li">{`Discover, Try, Buy`}</em>{` experiences.`}</li>
      <li parentName="ul">{`It’s acceptable to use `}<strong parentName="li">{`questions in headings`}</strong>{`. In both UIs and documentation, questions can be used to further conversational style. But don’t overuse them, as they can add to noise. Make sure headings that use questions are meaningful. In a UI, questions can also be used in a confirmation prompt in a dialog box. For example, `}<em parentName="li">{`“Do you want to close without saving?”`}</em></li>
      <li parentName="ul">{`Use `}<strong parentName="li">{`exclamation marks`}</strong>{` only positively, not negatively. Make sure you use no more than one exclamation mark in a context, such as a single window or a single Docs topic.`}</li>
    </ul>
    <DoDontRow mdxType="DoDontRow">
  <DoDont caption="Do use exclamation points for positive messages." text="Your IBM Cloud account is ready!" aspectRatio="1:1" mdxType="DoDont" />
  <DoDont type="dont" caption="Don’t use exclamation points for negative messages" text="You have reached your usage limit!!" aspectRatio="1:1" mdxType="DoDont" />
    </DoDontRow>
    <h4>{`Terms of politeness`}</h4>
    <p>{`Often overused, these terms can convey the wrong tone for technical material, and are not regarded the same way in all cultures. Use terms such as “please” and “thank you” carefully.`}</p>
    <DoDontRow mdxType="DoDontRow">
  <DoDont caption="Do use terms of politeness in a UI only when the user is being inconvenienced." text="Indexing might take a few minutes. Please wait." aspectRatio="1:1" mdxType="DoDont" />
  <DoDont type="dont" caption="Don’t use terms of politeness superfluously." text="Please create a subscription account to get full access to the catalog." aspectRatio="1:1" mdxType="DoDont" />
    </DoDontRow>
    <h2>{`Can, may, and might`}</h2>
    <h4>{`Terms of ability`}</h4>
    <p>{`These terms are often misused. Remember, “can” implies ability, and “may” implies permission (and sometimes uncertainty).`}</p>
    <DoDontRow mdxType="DoDontRow">
  <DoDont caption="Do use ‘can’ to express ability." text="You can use the command line interface to update your app." aspectRatio="1:1" mdxType="DoDont" />
  <DoDont type="dont" caption="Don’t use ‘may’ when you mean ‘can.’" text="You may use the command line interface to update your app." aspectRatio="1:1" mdxType="DoDont" />
    </DoDontRow>
    <h4>{`Terms of possibility`}</h4>
    <p>{`These terms can also be confusing. Remember, when either “may” or “might” will work, generally go with “might” to avoid confusion with the multiple meanings of “may.”`}</p>
    <DoDontRow mdxType="DoDontRow">
  <DoDont caption="Do use ‘might’ to clarify possibility." text="You might need more advanced features when integrating with another app." aspectRatio="1:1" mdxType="DoDont" />
  <DoDont type="dont" caption="Don’t use ‘may’ when ‘might’ will work." text="You may need more advanced features when integrating with another app." aspectRatio="1:1" mdxType="DoDont" />
    </DoDontRow>
    <h2>{`References`}</h2>
    <p>{`Eric Radzinski, Leslie McDonald, Amy Laird, Jana Jenkins, Peter Hayward, and Francis DeRespinis, `}<a parentName="p" {...{
        "href": "https://learning.oreilly.com/library/view/the-ibm-style/9780132118989/"
      }}>{`The IBM Style Guide: Conventions for Writers and Editors`}</a>{`, (IBM Press, 2011)`}</p>
    <p>{`Tom Waterton, `}<a parentName="p" {...{
        "href": "https://medium.com/@tomwaterton/how-to-emphasize-key-words-in-your-text-b8738f146972"
      }}>{`How to emphasize key words in your text`}</a>{`, (Medium, 2017)`}</p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      